import React from "react";
import { HIGHLIGHTS, standardClassname } from "utils/ToolTipConst";

// Tooltips for the VOW (Voices of Wetland) game legend
// These are intended to be consumed by InfoPopout in the VOW UI.

export const VowLegendTooltips: { [key: string]: React.ReactNode } = {
  // Habitats
  Woodland: (
    <div className={standardClassname}>
      <p className="font-semibold underline">Woodland</p>
      <p>
        Tree-dominated habitat. Generally <span className={HIGHLIGHTS.neutral}>lower duck potential</span>,
        but provides structure and biodiversity. Woodland can emerge if reedbeds
        remain dry and unmanaged.
      </p>
    </div>
  ),
  Reedbed: (
    <div className={standardClassname}>
      <p className="font-semibold underline">Reedbed</p>
      <p>
        Dense reeds in wet areas. <span className={HIGHLIGHTS.positive}>Key habitat for Bittern{" "}</span>
        and contributes to biodiversity. Harvesting affects habitat quality and nesting.
      </p>
    </div>
  ),
  Meadow: (
    <div className={standardClassname}>
      <p className="font-semibold underline">Meadow</p>
      <p>
        Open grassland. <span className={HIGHLIGHTS.positive}>Good for grazing (Herder)</span> and can
        shift toward reedbeds when wet or woodland when dry, depending on actions.
      </p>
    </div>
  ),
  "Open Water": (
    <div className={standardClassname}>
      <p className="font-semibold underline">Open Water</p>
      <p>
        Open permanent water. <span className={HIGHLIGHTS.neutral}>Supports ducks</span> and influences
        surrounding habitats. Water levels (WM choice) and actions can change adjacent tiles.
      </p>
    </div>
  ),

  // Status markers
  "Nature Reserve": (
    <div className={standardClassname}>
      <p className="font-semibold underline">Nature Reserve</p>
      <p>
        Tile is under protection for several years by the conservationist as a nature reserve. Most actions are blocked except
        nature reserve upkeep itself and nesting by bitterns.
      </p>
    </div>
  ),
  Nest: (
    <div className={standardClassname}>
      <p className="font-semibold underline">Nesting Location</p>
      <p>
        Indicates a Bittern nest attempt on this tile during the current act.
        Nests can be installed on any habitat, but only reedbeds with suitable spring
        flooding, no recent reed harvest, and no current grazing can succeed.
      </p>
    </div>
  ),
  Success: (
    <div className={standardClassname}>
      <p className="font-semibold underline">Nesting Success</p>
      <p>
        This icon indicates that a nest succesfully flourised here last year. <span className={HIGHLIGHTS.positive}>Adds to Births</span> and Bittern
        player score. Requires reedbed habitat, suitable spring flooding, no grazing during the act,
        no reed harvest in the previous act, and at least one flooded reedbed neighbor.
      </p>
    </div>
  ),
};

// Optional grouping if you want to categorize in the UI
export const VowLegendGroups = {
  habitat: ["Woodland", "Reedbed", "Meadow", "Open Water"],
  status: ["Nature Reserve", "Nest", "Success"]
};
